import { createContext } from "react"
import { ContextValue } from "./types"

// @ts-ignore
export const ConfirmDialogContext = createContext<ContextValue>()
